'use client';

import { Button } from '@/components/ui/button';
import { useOrderStore } from '@/store/useOrderStore';
import Step1CustomUpload from './Step1CustomUpload';

interface Props {
  onComplete: () => void;
}

export default function Step1QuoteInquiry({ onComplete }: Props) {
  const { itemInfo, phone } = useOrderStore();

  const isPhoneValid = /^01[016789]-\d{3,4}-\d{4}$/.test(phone);
  const hasContent =
    itemInfo.isCustom &&
    itemInfo.customData &&
    (itemInfo.customData.imageUrls.length > 0 || itemInfo.customData.linkUrl);

  const isValid = hasContent && isPhoneValid;

  return (
    <div className="space-y-4">
      <Step1CustomUpload />
      <Button
        onClick={onComplete}
        disabled={!isValid}
        className="w-full"
        size="lg"
      >
        다음으로
      </Button>
    </div>
  );
}
